import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, int32_type, list_type, bool_type, union_type, option_type, string_type, class_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Help_KundenportalTicketKategorie_$reflection, Help_UserTicketListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { UploadResult_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { Remote$1, Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { FormField__get_IsValid, update, FormField_InitWithDefault_74789EBD, ValidationRule, FormField_Init_Z1F39563A, FormField_$reflection } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { isEmpty, empty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { isNullOrWhiteSpace } from "../../../fable_modules/fable-library-js.4.19.0/String.js";

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Ticket", "MyTicket", "AllTickets", "PrefilledTicket"];
    }
}

export function Page_$reflection() {
    return union_type("Tickets.Types.Page", [], Page, () => [[], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item1", string_type], ["Item2", option_type(class_type("System.Guid"))]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadUserTicketList", "UserTicketListLoaded", "BetreffChanged", "TextChanged", "Submit", "Submitted", "UploadFiles", "FileUploaded", "DeleteUploadedFile", "UploadedFileDeleted", "MarkAntwortenAsShown", "MarkAntwortenAsShownSent", "LoadTicketKategorien", "TicketKategorienLoaded", "SelectedKundenportalTicketKategorieChanged", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Tickets.Types.Msg", [], Msg, () => [[["onlyMyTickets", bool_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Help_UserTicketListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Help_UserTicketListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [["Item", string_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", list_type(class_type("Browser.Types.File", undefined))]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [UploadResult_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", UploadResult_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", UploadResult_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("System.Guid"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("System.Guid")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", class_type("System.Guid")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Help_KundenportalTicketKategorie_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Help_KundenportalTicketKategorie_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", option_type(Help_KundenportalTicketKategorie_$reflection())]], [["Item", GlobalMsg_$reflection()]]]);
}

export class ResultText extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Success", "TooManyRequests", "PayloadTooLarge", "Error"];
    }
}

export function ResultText_$reflection() {
    return union_type("Tickets.Types.ResultText", [], ResultText, () => [[], [], [], []]);
}

export class Model extends Record {
    constructor(Name, Mail, Betreff, Text$, RechnungId, Sending, SendingResult, CurrentUploadCount, Uploading, CurrentUploadList, CurrentUploadSizeSum, ShowOnlyMyTickets, UserTickets, KundenportalTicketKategorien, SelectedKundenportalTicketKategorie, SelectedKundenportalTicketKategorieFormField, TicketToShow) {
        super();
        this.Name = Name;
        this.Mail = Mail;
        this.Betreff = Betreff;
        this.Text = Text$;
        this.RechnungId = RechnungId;
        this.Sending = Sending;
        this.SendingResult = SendingResult;
        this.CurrentUploadCount = (CurrentUploadCount | 0);
        this.Uploading = Uploading;
        this.CurrentUploadList = CurrentUploadList;
        this.CurrentUploadSizeSum = (CurrentUploadSizeSum | 0);
        this.ShowOnlyMyTickets = ShowOnlyMyTickets;
        this.UserTickets = UserTickets;
        this.KundenportalTicketKategorien = KundenportalTicketKategorien;
        this.SelectedKundenportalTicketKategorie = SelectedKundenportalTicketKategorie;
        this.SelectedKundenportalTicketKategorieFormField = SelectedKundenportalTicketKategorieFormField;
        this.TicketToShow = TicketToShow;
    }
}

export function Model_$reflection() {
    return record_type("Tickets.Types.Model", [], Model, () => [["Name", string_type], ["Mail", string_type], ["Betreff", FormField_$reflection()], ["Text", FormField_$reflection()], ["RechnungId", option_type(class_type("System.Guid"))], ["Sending", bool_type], ["SendingResult", option_type(ResultText_$reflection())], ["CurrentUploadCount", int32_type], ["Uploading", bool_type], ["CurrentUploadList", list_type(UploadResult_$reflection())], ["CurrentUploadSizeSum", int32_type], ["ShowOnlyMyTickets", bool_type], ["UserTickets", Remote$1_$reflection(list_type(Help_UserTicketListItem_$reflection()))], ["KundenportalTicketKategorien", list_type(Help_KundenportalTicketKategorie_$reflection())], ["SelectedKundenportalTicketKategorie", option_type(Help_KundenportalTicketKategorie_$reflection())], ["SelectedKundenportalTicketKategorieFormField", FormField_$reflection()], ["TicketToShow", option_type(class_type("System.Guid"))]]);
}

export function Model_Init(name, email, betreff, rechnungId, ticketToShow) {
    let Betreff_1;
    let model = new Model(name, email, FormField_Init_Z1F39563A(new ValidationRule(2, [150])), FormField_Init_Z1F39563A(new ValidationRule(2, [1000])), rechnungId, false, undefined, 0, false, empty(), 0, true, new Remote$1(1, []), empty(), undefined, FormField_InitWithDefault_74789EBD(new ValidationRule(0, []), ""), ticketToShow);
    if (!isNullOrWhiteSpace(betreff)) {
        model = ((Betreff_1 = update(model.Betreff, betreff), new Model(model.Name, model.Mail, Betreff_1, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow)));
    }
    return model;
}

export function Model__get_CanSubmit(x) {
    if (((!x.Sending && !x.Uploading) && FormField__get_IsValid(x.Text)) && FormField__get_IsValid(x.Betreff)) {
        return FormField__get_IsValid(x.SelectedKundenportalTicketKategorieFormField);
    }
    else {
        return false;
    }
}

export function ticketStatus(ticket) {
    if (ticket.IstErledigt) {
        if (isEmpty(ticket.Antworten)) {
            return "erledigt";
        }
        else {
            return "beantwortet";
        }
    }
    else {
        return "in Arbeit";
    }
}

//# sourceMappingURL=Types.fs.js.map
